'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);

var _components = require('../../../components');

var _PhoneVerificationForm = require('../PhoneVerificationForm.scss');var styles = _interopRequireWildcard(_PhoneVerificationForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Components

var VerificationCodeSection = function VerificationCodeSection(properties) {return (
    _react2.default.createElement('div', { key: 'codeSection', className: styles.codeSection },
      _react2.default.createElement('div', { className: styles.title }, properties.translate('verificationCodeMessage')),
      _react2.default.createElement('div', { className: styles.inputWrapper },
        _react2.default.createElement(_components.OMInputField, {
          maxLength: '4',
          placeholder: '' + properties.translate('codePlaceholder'),
          onChange: properties.onChange,
          isInvalid: !properties.codeIsValid,
          name: 'verificationCode',
          isValidIfEmpty: true,
          validate: properties.validateCode,
          isRtl: properties.isRtl }),


        properties.showCodePreloader ? _react2.default.createElement('span', { className: 'icon icon-om-spinner om-pulse' }) : null,


        properties.codeIsVerified ? _react2.default.createElement('span', { className: 'icon icon-check' }) : null),



      !properties.codeIsValid && !properties.codeIsVerified ?
      _react2.default.createElement('div', { className: styles.invalidMessage },
        properties.translate('invalidCodeMessage')) :

      null));}; // Styles
// Modules
exports.default =


VerificationCodeSection;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PhoneVerification/Sections/VerificationCodeSection.js
// module id = 2749
// module chunks = 0